import { render, staticRenderFns } from "./LabBaseMinio_.vue?vue&type=template&id=d8b24650&"
import script from "./LabBaseMinio_.vue?vue&type=script&lang=js&"
export * from "./LabBaseMinio_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports